import { FC, useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import queryString from 'query-string'
import Flatpickr from "react-flatpickr";
import {Vietnamese} from "flatpickr/dist/l10n/vn.js"
import { PaginateModel } from "../../../models/PaginateModel";
import { AbilityModel, SearchModel } from "../../../models/AbilityModel";
import { formatPrice, openNewTabWithHtml, revertPriceNumner } from "../../../selectors";
import { DATA_PAGINATION_LENGTH, PaginationLength } from "../../../../_metronic/partials/pagination/PaginationLength";
import * as AbilitiesCRUD from '../AbilitiesCRUD';
import { PaginationHeader } from "../../../../_metronic/partials/pagination/PaginationHeader";
import { Paginate } from "../../../../_metronic/partials/pagination/Paginate";
import PaymentVoucherTable from "./PaymentVoucherTable";
import { ABILITIES_TYPES, DEFAULT_PER_PAGE, FORCE_BANKING_METHOD, LIST_PERMISSIONS, PAYMENT_VOUCHER, PAYMENT_VOUCHER_TYPE_OPTIONS } from "../../../constants/common";
import PaymentVoucherModal from "./PaymentVoucherModal";
import { Confirm, Toast, download } from "../../../modules/common/helper";
import moment from "moment";
import {GetStoreIfo, Sento, usePermissionChecker, UserLoggedIn} from "../../../hooks/PermissionChecker";
import { HeaderModel, ModalModel } from "../../../models/CommonModel";
import ConfigModal from "./ConfigModal";
import useMasterData from "../../../hooks/useMaster";
import parseParams from "../../../selectors/formatParams";
import { NumericFormat } from "react-number-format";

const PaymentVoucher: FC = () => {
    const intl = useIntl();
    const history = useHistory();
    const [selectedIds, setSelectedIds] = useState<number[]>([])
    const [dataPaginate, setDataPaginate] = useState<PaginateModel<AbilityModel>>();
    const sento = Sento();
    const { master } = useMasterData();
    const { hasPermission } = usePermissionChecker();
    const storeInfo = GetStoreIfo();
    const fp = useRef<any>(null);
    const [hideCols, setHideCols] = useState<string[]>([
        'date',
        'note',
        'doc_label'
    ]);
    const [invoiceFile, setInvoiceFile] = useState<File|null>(null)
    const [configModal, setConfigModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });
    const type: any = ABILITIES_TYPES.find((e) => {
        return e.label == PAYMENT_VOUCHER
    });
    const [paymentVoucherModal, setModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });
    const searchHistory = history.location.search;
    const initParams: SearchModel = parseParams(queryString.parse(searchHistory))
    const initRange:any = [initParams?.start_date ?? moment().format('YYYY-MM-DD'), initParams?.end_date ?? moment().format('YYYY-MM-DD')]
    const initSearch = {
        page: 1,
        per_page: DEFAULT_PER_PAGE,
        start_date: initRange[0],
        end_date: initRange[1]
    }
    const [search, setSearch] = useState<SearchModel>(initSearch)
    const [subTotal, setSubTotal] = useState<number>(0)
    
    useEffect(() => {
		document.title = 'Sento - Phiếu chi';
	})

    useEffect(() => {
        const searchHistory = history.location.search;
        const initParams: SearchModel = parseParams(queryString.parse(searchHistory))
        getData({ ...search, ...initParams });
    }, []);

    const getData = async (params?: SearchModel) => {
        let searchQ = {...params, type: type?.id};
        if (searchQ?.start_date && searchQ.end_date) {
            searchQ = {...searchQ, date: {startDate: searchQ.start_date, endDate: searchQ.end_date}}
        }
        const { data: resData } = await AbilitiesCRUD.getList(searchQ);
        const objQuery = { ...params }
        if (objQuery.page === 1) {
            delete objQuery.page
        }
        if (objQuery.per_page === DEFAULT_PER_PAGE) {
            delete objQuery.per_page
        }
        history.push({ search: `?${queryString.stringify(objQuery)}` })
        setDataPaginate(resData?.paginate_data);
        setSubTotal(resData?.sub_total);
        setSearch(params ?? {});
    }

    const handlePageChange = (data: any) => {
        getData({ ...search, page: data.selected + 1 })
    }

    const handlePageLengthChange = (e: any) => {
        getData({ ...search, page: 1, per_page: +e.target.value })
    }

    const handleSearch = (e: any) => {
        e.preventDefault();
        getData({ ...search, page: 1 })
    }

    const handleClearSearch = (e: any) => {
        e.preventDefault();
        setSearch(initSearch);
        if (fp.current?.flatpickr) {
            fp.current.flatpickr.clear();
        }
        getData(initSearch)
    }

    const formatAbilityData = (values: any) => {
        let expensesArr = ['payroll','electric','water','telecom','rent','manage','depreciation','interest', 'other'];
        let payrollPurpose = ['salary','s_insurance','h_insurance','u_insurance'];
        let abilityData = {...values};
        if (abilityData.expense_group === 'debt') {
            return {
                ...abilityData, 
                expense_group: null, 
                purpose: 'expenses'
            }
        }

        if (abilityData.expense_group === 'tax') {
            return {
                expense_group: null, 
                purpose: 'tax',
                name: abilityData.name,
                value: abilityData.value,
                payment_method: abilityData.payment_method,
                note: abilityData.note ??  null,
                date: abilityData.date,
                doc_label: abilityData.doc_label ?? null
            }
        }

         if (abilityData.expense_group === 'bank_fee') {
            return {
                expense_group: 'other', 
                purpose: 'bank_fee',
                name: abilityData.name,
                value: abilityData.value,
                payment_method: 'banking',
                note: abilityData.note ??  null,
                date: abilityData.date,
                doc_label: abilityData.doc_label ?? null
            }
        }

        let purpose = abilityData.purpose
        let expenseGroup = abilityData.expense_group ?? null;
        
        if (expensesArr.includes(abilityData.expense_group)) {
            purpose = 'expenses';
            if (abilityData.expense_group === 'payroll') {
                purpose = payrollPurpose.includes(abilityData.purpose ?? '') ? abilityData.purpose : 'salary';
            }

            return {
                expense_group: abilityData.expense_group, 
                purpose: purpose,
                name: abilityData.name,
                value: abilityData.value,
                payment_method: abilityData.payment_method,
                note: abilityData.note ?? null,
                date: abilityData.date,
                doc_label: abilityData.doc_label ?? null
            }
        } else {
            purpose = abilityData.expense_group;
            expenseGroup = null;
        }

        let paymentMethod = abilityData.payment_method;
        if (FORCE_BANKING_METHOD.includes(expenseGroup)) {
            paymentMethod = 'banking';
            purpose = expenseGroup;

            if (purpose === 'bank_fee') {
                expenseGroup = 'other'
            }
        }
        
        return {
            ...abilityData,
            purpose,
            payment_method: paymentMethod,
            expense_group: expenseGroup
        }
    }

    const handleSubmit = async (values: any, actions: any) => {
        let abilityData = formatAbilityData(values);
        const formData = new FormData();
        Object.keys(abilityData).forEach((key) => {
            if (abilityData[key] !== null) {
                formData.append(key, abilityData[key]);
            }
        });

        if (invoiceFile) {
            formData.append('file', invoiceFile);    
        }
        
        if (values?.id) {
            handleUpdateAbility(formData, values.id)
            return;
        }

        handleCreateAbility(formData)
    };

    const handleCreateAbility = async (formData: FormData) => {
        let result = AbilitiesCRUD.store(formData);
        let message = 'Tạo phiếu chi thành công!'
        result.then(res => {
            Toast.fire({
                icon: 'success',
                title: message
            })
            setModal({ ...paymentVoucherModal, show: false })
            getData({ ...search, page: 1 })
        }).catch(error => {
            const response = error.response
            let message: string = '';
            if (response?.status === 422) {
                if (response?.data?.errors) {
                    const arrMess = [];
                    for (const [key, mess] of Object.entries(response?.data?.errors)) {
                        arrMess.push(mess);
                    }
                    message = arrMess.join("\n")
                }
            } else {
                message = 'Đã có lỗi xảy ra vui lòng liên hệ Admin'
            }
            Toast.fire({
                icon: 'error',
                title: message
            })
        });

    }

    const handleUpdateAbility = async (formData: FormData, id: number) => {
        let result = AbilitiesCRUD.update(formData, id);
        let message = 'Cập nhật phiếu chi thành công!'
        result.then(res => {
            Toast.fire({
                icon: 'success',
                title: message
            })
            setModal({ ...paymentVoucherModal, show: false })
            getData({ ...search, page: 1 })
        }).catch(error => {
            const response = error.response
            let message: string = '';
            if (response?.status === 422) {
                if (response?.data?.errors) {
                    const arrMess = [];
                    for (const [key, mess] of Object.entries(response?.data?.errors)) {
                        arrMess.push(mess);
                    }
                    message = arrMess.join("\n")
                }
            } else {
                message = 'Đã có lỗi xảy ra vui lòng liên hệ Admin'
            }
            Toast.fire({
                icon: 'error',
                title: message
            })
        });

    }

    const handleExportPdf = async (id: number) => {
        const {data: resData} = await AbilitiesCRUD.exportPdf({id: id, type: type?.id})
        openNewTabWithHtml(resData);
        // download(resData, 'phieu-chi-'+id, 'pdf')
    }
    
    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            handleSearch(e);
        }
    }

    const header: HeaderModel[] = [
        {
            label: intl.formatMessage({ id: 'ABILITIES.DATE' }),
            style: { minWidth: "100px" },
            field: 'created_at',
            sortable: true
        },
        {
            label: 'Ngày sao kê',
            style: { minWidth: "100px" },
            field: 'date',
            sortable: true
        },
        {
            label: intl.formatMessage({ id: 'ABILITIES.PAYER' }),
            style: { minWidth: "120px" },
            field: 'name',
            sortable: true
        },
        {
            label: 'Ngân hàng',
            style:  { minWidth: "150px" },
            field: 'bank_id',
            sortable: true
        },
        {
            label: intl.formatMessage({ id: 'ABILITIES.DESCRIPTION' }),
            style: { minWidth: "150px" },
            field: 'note',
            sortable: true
        },
        {
            label: intl.formatMessage({ id: 'ABILITIES.PAYMENT_AMOUNT' }),
            style: { minWidth: "110px" },
            field: 'value',
            sortable: true
        },
        {
            label: 'Loại chi phí',
            style: { minWidth: "120px" },
            field: 'expense_group',
            sortable: false
        },
        {
            label: 'Phương thức thanh toán',
            style: { minWidth: "120px" },
            field: 'payment_method',
            sortable: true
        },
        {
            label: 'Tài liệu',
            style: { minWidth: "120px" },
            field: 'doc_label',
            sortable: false
        }
    ]

    const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
        const currentSearch = { ...search };
        const sortParams: SearchModel = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
        if (direction === 'none') {
            delete sortParams.sort_by;
            delete sortParams.sort_direction;
        }
        getData({ ...sortParams });
    }

    const handleChangeVisCols = (e: any) => {
        let hiddenCols = [...hideCols];
        if (!e.target?.checked) {
            setHideCols([...hiddenCols, e.target.name])
        } else {
            setHideCols(hiddenCols.filter((item) => item !== e.target.name))
        }
    }

    const handleExport = async () => {
        const { data } = await AbilitiesCRUD.exportCsv({ ...search, type: type?.id });
        download(data, 'ability');
    }

    const handleCheck = (e: any, item: AbilityModel) => {
        let newCheckedIds = [...selectedIds];
        if (e.target.checked) {
            newCheckedIds.push(item.id)
        } else {
            newCheckedIds = newCheckedIds.filter((id) => id !== item.id)
        }

        setSelectedIds([...newCheckedIds])
    }

    const handleCheckAll = (e: any) => {
        let newCheckedIds = [...selectedIds];
        let ids: number[] = dataPaginate?.data?.map((item: AbilityModel) => item.id) ?? [];
        if (e.target?.checked) {
            newCheckedIds = newCheckedIds.concat(ids);
        } else {
            newCheckedIds = newCheckedIds.filter((id) => !ids.includes(id))
        }
        setSelectedIds([...newCheckedIds])
    }

    const handleDelete = async () => {
        
        Confirm.fire({
            icon: 'question',
            title: intl.formatMessage({ id: 'COMMON.CONFIRM_DELETE' }, { name: 'các đơn dữ liệu đã chọn' }),
            confirmButtonText: intl.formatMessage({ id: 'COMMON.YES' }),
            cancelButtonText: intl.formatMessage({ id: 'COMMON.NO' }),
        }).then(async (res) => {
            if (res.isConfirmed) {
                try {
                    const res = await AbilitiesCRUD.remove(selectedIds);
                    Toast.fire({
                        icon: 'success',
                        title: res?.data?.message || intl.formatMessage({ id: 'COMMON.SUCCESS_NOTY' }),
                    })
                    setSelectedIds([])
                } finally {
                    getData({ ...search, page: 1 })
                }
            }
            
        })
    }

    return <>
        <div className="card">
            <div className="card-header p-3">
                <div className="col-md-12">
                    <form onSubmit={handleSearch}>
                        <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">{intl.formatMessage({ id: 'COMMON.KEYWORD' })}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    name="keyword"
                                    value={search.keyword || ''}
                                    onChange={(e) => setSearch({ ...search, keyword: e.target.value })}
                                    autoComplete='nope'
                                    onKeyDown={(e) => handleKeyDown(e)}
                                />
                            </div>
                            <div className='col-md-3 mb-2'>
                                <label className="form-label">{intl.formatMessage({id: 'COMMON.TIME'})}</label>
                                <Flatpickr
                                    ref={fp}
                                    onChange={(date) => {
                                        let startDate = moment(date[0]).format('YYYY-MM-DD');
                                        let endDate = moment(date[1]).format('YYYY-MM-DD');
                                        setSearch({ ...search, start_date: startDate, end_date: endDate });
                                    }}
                                    options={{
                                        mode: "range",
                                        dateFormat: "d-m-Y",
                                        locale: Vietnamese,
                                        shorthandCurrentMonth: true,
                                        defaultDate: [moment(initRange[0]).format('DD-MM-YYYY'), moment(initRange[1]).format('DD-MM-YYYY')],
                                    }}
                                    className='form-control'
                                    placeholder=''
                                />
                            </div>
                            <div className="col-md-3 mb-2">
                                <label className="form-label">Loại chi phí</label>
                                <select
                                    className="form-select"
                                    value={search.expense_group}
                                    onChange={(e) => setSearch({ ...search, expense_group: e.target.value })}
                                    name="expense_group"
                                >
                                    <option value="">Tất cả</option>
                                    {PAYMENT_VOUCHER_TYPE_OPTIONS.filter((opt) => opt.value !== 'sales_refund').map((opt) => {
                                        return <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    })}
                                </select>
                            </div>
                            <div className="col-md-3 mb-2">
                                <label className="form-label">Dòng tiền chi</label>
                                <select
                                    className="form-select"
                                    value={search.payment_method}
                                    onChange={(e) => {
                                        let newSearch = { ...search, payment_method: e.target.value }
                                        if (e.target.value !== 'banking') {
                                            newSearch = {...newSearch, bank_id: undefined}
                                        }
                                        setSearch({ ...newSearch })
                                    }}
                                    name="payment_method"
                                >
                                    <option value=''>Tất cả</option>
                                    <option value='banking'>Chuyển khoản</option>
                                    <option value='cash'>Tiền mặt</option>
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-md-3'>
                                <label className="form-label">Giá từ</label>
                                <NumericFormat
                                    name='value_from'
                                    thousandSeparator=","
                                    className={'form-control'}
                                    key={search?.value_from}
                                    value={search?.value_to}
                                    onBlur={(e) => {
                                        setSearch({ ...search, value_from: revertPriceNumner(e.target.value) })
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e)}
                                />
                            </div>
                            <div className='col-md-3'>
                                <label className="form-label">Giá đến</label>
                                <NumericFormat
                                    name='value_to'
                                    thousandSeparator=","
                                    key={search?.value_to}
                                    className={'form-control'}
                                    value={search?.value_to}
                                    onBlur={(e) => {
                                        setSearch({ ...search, value_to: revertPriceNumner(e.target.value) })
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Ngân hàng</label>
                                <select 
                                    className="form-select" 
                                    value={search?.bank_id ?? ''}
                                    onChange={(e) => setSearch({ ...search, bank_id: e.target.value ? parseInt(e.target.value) : undefined })}
                                    name="bank_id">
                                    <option value="">Tất cả</option>
                                    {storeInfo?.banks?.map((bank, key) => <option value={bank?.id} key={`a_bank_${key}`}>{bank?.bank_name} - {bank?.bank_account_number}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-md-4 mb-2 mt-2'>
                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                <input 
                                    className='form-check-input' 
                                    type='checkbox' 
                                    name='filter_by_date' 
                                    checked={search?.filter_by_date == 1} 
                                    onChange={(e) => setSearch({ ...search, filter_by_date: e.target.checked ? 1 : 0 })}
                                />
                                <span className='form-check-label'>Lọc theo ngày sao kê</span>
                            </label>
                            </div>
                        </div>
                        <div className="btns-group">
                            <button
                                className="col-auto btn btn-primary mt-3 me-2"
                                onClick={handleSearch}
                            >
                                <i className="bi bi bi-search fs-4"></i> {intl.formatMessage({ id: 'COMMON.SEARCH' })}
                            </button>
                            <button
                                className="col-auto btn btn-danger mt-3 me-2"
                                type="button"
                                onClick={handleClearSearch}
                            >
                                <i className="bi bi-eraser-fill fs-1"></i> Re-search
                            </button>
                            <button className="btn btn-icon mt-3 me-2 btn-light-info me-5 text-hover-white" type="button"
                            onClick={handleExport}>
                                <i className="bi bi-cloud-arrow-down-fill fs-1 text-info" />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div className="card-body p-3">
                <div className="row justify-content-between align-items-center mb-3">
                    <div className='col-7 col-md-9'>
                        <PaginationHeader from={dataPaginate?.meta?.from || 0} to={dataPaginate?.meta?.to || 0}
                            total={dataPaginate?.meta?.total || 0} />
                        <h3>Tổng cộng: <span className="text-bold">{ formatPrice(subTotal) } VNĐ</span></h3>
                    </div>
                    <div className='col-5 col-md-3 text-end'>
                        {(hasPermission(LIST_PERMISSIONS.ABILITIES_DELETE) && selectedIds?.length > 0) && (
                            <button
                                className="col-auto btn btn-danger btn-sm"
                                type="button"
                                onClick={handleDelete}
                            >
                                {intl.formatMessage({id: 'COMMON.DELETE'})}
                            </button>
                        )}
                        <button
                            className="col-auto btn btn-primary btn-sm ms-2"
                            type="button"
                            onClick={() => setModal({...paymentVoucherModal, show: true, mode: 'add', data: undefined})}
                        >
                            <i className="bi bi-plus fs-14"></i> {intl.formatMessage({id: 'COMMON.CREATE'})}
                        </button>
                    </div>
                </div>
                <PaymentVoucherTable 
                    data={dataPaginate?.data || []}
                    handleExportPdf={handleExportPdf}
                    openColConfig={() => setConfigModal({ ...configModal, show: true })}
                    header={header}
                    hideCols={hideCols}
                    handleSort={handleSort}
                    handleCheck={handleCheck}
                    selectedIds={selectedIds}
                    handleCheckAll={handleCheckAll}
                    handleEditItem={(item: AbilityModel) => setModal({...paymentVoucherModal, mode: 'edit', data: item, show: true})}
                    canEdit={hasPermission(LIST_PERMISSIONS.ABILITIES_EDIT)}
                />
                <PaymentVoucherModal
                    {...paymentVoucherModal}
                    onClose={() => { setModal({ ...paymentVoucherModal, show: false }) }}
                    onSubmit={handleSubmit}
                    setInvoiceFile={setInvoiceFile}
                />
            </div>
            <div className="card-footer d-flex justify-content-between paginate-wrapper">
                <PaginationLength selected={search.per_page || DEFAULT_PER_PAGE} onChange={handlePageLengthChange} />
                <Paginate
                    pageCount={dataPaginate?.meta?.last_page || 0}
                    onPageChange={handlePageChange}
                    forcePage={(search.page || 1) - 1}
                />
            </div>
            <ConfigModal
                {...configModal}
                header={header}
                hideCols={hideCols}
                handleChangeVisCols={handleChangeVisCols}
                onClose={() => { setConfigModal({ ...configModal, show: false }) }}
            />
        </div>
    </>
}
export default PaymentVoucher;